var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 12.875C10.0208 12.875 12.875 10.0208 12.875 6.5C12.875 5.30989 12.5489 4.19594 11.9811 3.24265L7.1467 8.61426C6.45402 9.3839 5.28846 9.49759 4.46011 8.87633L2.35833 7.3C1.91651 6.96863 1.82696 6.34183 2.15833 5.9C2.48971 5.45817 3.11651 5.36863 3.55833 5.7L5.66011 7.27633L10.6861 1.69187C9.5662 0.715993 8.10211 0.125 6.5 0.125C2.97918 0.125 0.125 2.97918 0.125 6.5C0.125 10.0208 2.97918 12.875 6.5 12.875Z",
    fill: "#0877FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.e839e16460de40bdf8e08cb17f499a27.svg";
export { ForwardRef as ReactComponent };